import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ApiResponse } from "../../api/apiResponse";
import { resendInvitation } from "../../api/endpoints/Invitations/invitations";
import LinkHero from "../../assets/heroes/link-hero.png";
import AppLogo from "../../components/AppLogo";
import AppInput from "../../components/forms/AppInput";
import ChangeLangButton from "../../components/language/ChangeLangButton";
import LoadingSpinner from "../../components/LoadingSpinner";
import LogoWithLanguage from "../../components/logo-with-language/LogoWithLanguage";
import { makeApiRequest } from "../../helpers";

function ExpiredPage() {
  const LocalBasePath = "page.expired";
  let { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data: any) => {
    setIsLoading(true);
    await makeApiRequest(
      () => resendInvitation(id, data.email),
      (response: ApiResponse) => {
        navigate(`/login`);
      }
    );
    setIsLoading(false);
  };
  return (
    <>
      <div className="flex min-h-screen">
        <div className="flex flex-col justify-between flex-1 px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="flex flex-col items-center justify-center w-full h-full mx-auto md:max-w-sm lg:w-96">
            <div>
              <div className="flex flex-col items-center justify-center gap-4 sm:gap-0 sm:justify-between sm:flex-row">
                <LogoWithLanguage />
              </div>
              <h2 className="mt-6 text-3xl font-bold text-gray-700">
                {t("unfortunately")}
              </h2>
              <p className="mt-2 text-lg leading-6 text-gray-500">
                {t("contactTheLiaison")}
              </p>
              <div className="mt-6">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <AppInput
                      label={t("email")}
                      id="email"
                      type="email"
                      autoComplete="email"
                      error={errors.email}
                      name="email"
                      register={register}
                      scehema={{
                        required: false,
                        pattern: /^\S+@\S+$/i,
                      }}
                    />
                  </div>
                  <div className="mt-6">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                    >
                      {t("send")}
                      {isLoading && (
                        <span className="ms-2">
                          <LoadingSpinner size={15} />
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="relative flex-1 hidden w-0 lg:block">
          <img
            className="absolute inset-0 object-cover w-full h-full"
            src={LinkHero}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
export default ExpiredPage;
